import { render } from "./reviuDAK.vue?vue&type=template&id=1a229852"
import script from "./reviuDAK.vue?vue&type=script&lang=js"
export * from "./reviuDAK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__